import script from "./BaseTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTable.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTable.vue?vue&type=style&index=0&id=cc50f11c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc50f11c"]])

export default __exports__